export default {
	host:'http://43.142.87.40',
	port:2465,
	socketurl:'ws://43.142.87.40:3465'
}